// FIXME
// eslint-disable-next-line workspaces/require-dependency
import { type ActionMeta } from '@databases/atlaskit/Select';
import { type PageLabelsDelta } from '@databases/types/database';

interface PageLabelsPickerOption {
  label: string;
  value: string;
}

export function getLabelsDelta(
  action: ActionMeta<PageLabelsPickerOption>
): PageLabelsDelta | undefined {
  switch (action.action) {
    case 'select-option':
      return action.option ? { add: [action.option.value], remove: [] } : undefined;

    case 'deselect-option':
      return action.option ? { add: [], remove: [action.option.value] } : undefined;

    case 'remove-value':
    case 'pop-value':
      if (action.removedValue) {
        return { add: [], remove: [action.removedValue.value] };
      } else {
        // action.removedValue is undefined when pressing backspace in an empty field (typings are wrong)
        return undefined;
      }

    case 'clear':
      return { add: [], remove: action.removedValues.map((o) => o.value) };

    // create-option should never be triggered, as we use a regular option for creation
    default:
      throw new Error(`Invalid label picker action "${action.action}".`);
  }
}
